















import { Component, Prop, Vue, Emit } from "vue-property-decorator";
import VueGoogleAutocomplete from "vue-google-autocomplete";

@Component({
  components: {
    VueGoogleAutocomplete
  }
})
export default class AddressSearch extends Vue {
  @Prop() id?: string;
  // @Prop() placeholder: string;

  placeChanged(place: any) {
    this.$emit("placeChanged", place);
  }
  clear() {
    // @ts-ignore
    this.$refs.address.clear();
  }
}
